import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { Container, Row, Col, BodyText, Card } from '@paypalcorp/pp-react'
import { PrivacyHubLink, PrivacyHubModalLink } from './common'
import { func } from 'prop-types'
import serverData from '../../utils/server-data'
import Section from '../../components/privacyHub/section'
import PrivacyHubHeader from '../../components/privacyHub/privacy-hub-header'
import {
  constructConfigForSection,
  homeConfig,
  directionality,
} from '../../config/privacy-hub'

const PrivacyHubPrinciplesSection = memo(() => {
  return (
    <>
      <Container className="privacy-hub-section-container">
        <div className="privacy-hub-wrapper">
          <PrivacyHubHeader {...homeConfig.headerSection('home')}>
            <PrivacyHubLink
              name="privacyStatement"
              message="privacyhub.home.privacyprinciples.link"
              href="/webapps/mpp/ua/privacy-full"
              id="readOurPrivacyStmtLink"
            />
          </PrivacyHubHeader>
        </div>
      </Container>
    </>
  )
})

PrivacyHubPrinciplesSection.displayName = 'PrivacyHubPrinciplesSection'

const PrivacyHubMainLinkSection = memo(({ onSectionClick }) => (
  <Container className="privacy-hub-section-container">
    <div
      className={`privacy-hub-wrapper privacy-hub-main-links-wrapper ${directionality}`}
    >
      <Row className="main-links-row" noGutters>
        {homeConfig.mainLinks.map(
          ({
            id,
            name,
            icon,
            title,
            description,
            link,
            className,
            href = '',
            modal = '',
          }) => (
            <Col
              className={`privacy-hub-card-container  ${className}`}
              xs={12}
              md={6}
              key={title}
            >
              <Container fluid className="container-wrapper">
                <Section
                  {...constructConfigForSection('Main_Links', {
                    description: {
                      class: 'privacy-hub-text privacy-hub-description',
                      id: `${name}Desc`,
                      messageId: description,
                      size: 'sm',
                    },
                    heading: {
                      size: 'sm',
                      class: 'privacy-hub-text privacy-hub-link-title ',
                      id: `${name}Title`,
                      messageId: title,
                    },
                    component_icon: {
                      name: icon.name,
                      size: icon.size,
                      color: icon.color,
                      svgIconClass: icon.class,
                    },
                  })}
                >
                  {href ? (
                    <PrivacyHubLink
                      message={link}
                      href={href}
                      name={name}
                      id={id}
                    />
                  ) : (
                    <PrivacyHubModalLink
                      id={id}
                      name={name}
                      message={link}
                      onSectionClick={() =>
                        onSectionClick({
                          name: modal,
                          title: (
                            <BodyText
                              className="privacy-hub-body-text"
                              id="manageYourDataTitle"
                            >
                              <Message id="privacyhub.privacyrights.modal.title" />
                            </BodyText>
                          ),
                        })
                      }
                    />
                  )}
                </Section>
              </Container>
            </Col>
          ),
        )}
      </Row>
    </div>
  </Container>
))
PrivacyHubMainLinkSection.propTypes = {
  onSectionClick: func.isRequired,
}

PrivacyHubMainLinkSection.displayName = 'PrivacyHubMainLinkSection'

const PrivacyHubOthersAndDataSection = memo(() => (
  <Container className="privacy-hub-section-container">
    <div
      className={`privacy-hub-wrapper privacy-hub-card-other-data-section-wrapper ${directionality}`}
    >
      <Row className="row" noGutters>
        {homeConfig.othersAndData.map(
          ({ key, title, description, href, name, svg_icon }, index) => (
            <Card
              className={
                index === homeConfig?.othersAndData?.length - 1
                  ? 'privacy-hub-card privacy-hub-card-last '
                  : 'privacy-hub-card'
              }
              onClick={() => {
                window.location.href = href
              }}
              label="Clickable Card"
              key={key}
            >
              <Section
                {...constructConfigForSection('Card_section', {
                  description: {
                    class: 'privacy-hub-description privacy-hub-text',
                    id: `${name}Desc`,
                    messageId: description,
                    size: 'sm',
                  },
                  heading: {
                    size: 'lg',
                    class:
                      'privacy-hub-text privacy-hub-card-heading privacy-hub-description ',
                    id: `${name}Title`,
                    messageId: title,
                  },
                  icon_svg_link: {
                    imgSrc: svg_icon.src,
                    imgClass: svg_icon.class,
                    alt: key,
                  },
                })}
              />
            </Card>
          ),
        )}
      </Row>
    </div>
  </Container>
))

PrivacyHubOthersAndDataSection.displayName = 'PrivacyHubOthersAndDataSection'

const PrivacyHubBusinessSection = memo(() => (
  <Container className="privacy-hub-section-container privacy-hub-bussiness-section">
    <Card className="privacy-hub-no-bg-card no-box-shadow">
      <div className="privacy-hub-wrapper">
        <Section
          {...constructConfigForSection('Card_section', {
            description: {
              class:
                'privacy-hub-text  privacy-hub-heading-description  text-center',
              id: 'privacyhubHomeBusinessDesc',
              messageId: 'privacyhub.home.business.desc',
              size: 'sm',
            },
            heading: {
              size: 'lg',
              class: 'privacy-hub-text privacy-hub-card-heading   text-center',
              id: 'privacyhubHomeBusinessTitle',
              messageId: 'privacyhub.home.business.title',
            },
            icon_svg_link: {
              imgSrc: `https://${serverData.cdnHostName}/paypal-ui/pictograms/blue/svg/businesses-blue.svg`,
              imgClass: 'privacy-hub-business-image privacy-hub-m-auto',
              alt: 'merchant',
            },
          })}
        >
          <div className="text-center">
            <PrivacyHubLink
              name="privacyFAQsForBusinesses"
              message="privacyhub.home.business.link"
              href="/myaccount/privacy/privacyhub/business"
              id="privacyhubHomeBusinessLink"
            />
          </div>
        </Section>
      </div>
    </Card>
  </Container>
))

PrivacyHubBusinessSection.displayName = 'PrivacyHubBusinessSection'

const PrivacyHubHome = memo(({ onSectionClick }) => (
  <div id="privacy-hub-home">
    <PrivacyHubPrinciplesSection />
    <PrivacyHubMainLinkSection onSectionClick={onSectionClick} />
    <PrivacyHubOthersAndDataSection />
    <PrivacyHubBusinessSection />
  </div>
))

PrivacyHubHome.propTypes = {
  onSectionClick: func.isRequired,
}

PrivacyHubHome.displayName = 'PrivacyHubHome'

export default PrivacyHubHome
